import VueTableDynamic from './components/VueTableDynamic.vue'

VueTableDynamic.install = function (Vue, options) {
  Vue.component('VueTableDynamic', VueTableDynamic)
}

export default VueTableDynamic
